import RGBA from '../Fonts/RGBA'

// set debug to true to have the colors selected randomly.
const debug = false;

// set lsdMode to true to have the colors selected randomly
// each time a color is requested.
const lsdMode = false;

class ColorSchemeRepository
{

  constructor() {

    // set default colors
    this.colors = {
      wallBackground                : '#16224B',
      foregroundText                : '#FFFFFF',
      eventTimeForegroundText       : '#86b1ca',
      roomBackground                : '#0C6294',
      roomStageBackground           : '#124F80',
      roomChildBackground           : '#124F80',
      roomChildActiveBackground     : '#17234a',
      personBackground              : '#0d76b3',
      indicatorBackground           : '#16224b',
      toggleBackground              : '#30c700',
    };

    if (debug) {
      Object.keys(this.colors).forEach(n => {
        this.colors[n] = new RGBA().random();
      });
    }

  }

  /**
   * Set one or more colors on the colorScheme. Provide with a
   * slug and a value to set one color or a key-pair object
   * to set multiple colors at once.
   *
   * @param {object|string} slug
   * @param {null|string} value
   * @returns this
   */
  set(slug, value) {

    if (typeof slug === 'object') {

      Object.keys(slug).forEach(n => {

        this.set(n, slug[n]);

      });
      return this; // chainable
    }

    if (this.colors.hasOwnProperty(slug)) {
      this.colors[slug] = value;
      return this;
    }

    console.warn('Setting undefined color: ' + slug + '. Color must be one of [' + Object.keys(this.colors).join(', ') + ']');

    return this; // chainable

  }

  get(slug) {

    if (lsdMode) {
      return new RGBA().random();
    }

    if (this.colors.hasOwnProperty(slug)) {
      return this.colors[slug];
    }

    console.warn('Requested undefined color: ' + slug);

  }

}

let colorSchemeRepository = new ColorSchemeRepository();
export default colorSchemeRepository;
